import React from 'react';
import { Button, Modal, List, Input } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { ReactSVG } from 'react-svg';
import { COLORS } from '../../../constants';
import './SwapRider.scss';

const { Search } = Input;

const SwapRider = ({ state, handleOk, handleCancel, handleSelectedRoute, onSearchRiders }) => {
  return (
    <Modal
      open={state.visibleModal}
      title="Swap Rider"
      onOk={handleOk}
      onCancel={handleCancel}
      forceRender
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          CANCEL
        </Button>,
        <Button key="submit" type="primary" disabled={Object.keys(state.swapToRoute).length === 0} onClick={handleOk}>
          SWAP RIDER
        </Button>,
      ]}
      width={370}
      className="swap-rider-modal"
    >
      <div className="ListRiders">
        <Search className="mb-3" placeholder="Search Rider" onChange={(e) => onSearchRiders(e)} />
        <List>
          {state.searchedRoutes?.map((route, index) => {
            const user = route.user || {};
            const color = COLORS[route.riderId % COLORS.length];
            return (
              <List.Item key={index}>
                <div className="content">
                  <div className="left">
                    <span role="img" aria-label="support" className="anticon rider">
                      <ReactSVG className={`ReactSVG-${color}`} src={`/icons/riders.svg`} />
                    </span>
                    <b>{user.name}</b>
                  </div>
                  <div className="right">
                    <Button type="link" onClick={() => handleSelectedRoute(route)}>
                      {route.riderId === state.swapToRoute.riderId && (
                        <span className="selected">
                          {' '}
                          Selected <CheckOutlined />{' '}
                        </span>
                      )}
                      {route.riderId !== state.swapToRoute.riderId && <span className="select"> Select </span>}
                    </Button>
                  </div>
                </div>
              </List.Item>
            );
          })}
        </List>
      </div>
    </Modal>
  );
};

export default SwapRider;
